import { SectionHeading, Subheading as SubheadingBase } from 'components/misc/Headings.js';
import { SectionDescription } from 'components/misc/Typography.js';
import styled from 'styled-components';
import tw from 'twin.macro';

import defaultCardImage from 'images/shield-icon.svg';

import { ReactComponent as SvgDecoratorBlob3 } from 'images/svg-decorator-blob-3.svg';

import CustomizeIconImage from 'images/customize-icon.svg';
import FastIconImage from 'images/fast-icon.svg';
import ReliableIconImage from 'images/reliable-icon.svg';
import ShieldIconImage from 'images/shield-icon.svg';
import SimpleIconImage from 'images/simple-icon.svg';
import SupportIconImage from 'images/support-icon.svg';

const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
    ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-6 md:py-8`}
`;
const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)`font-black text-3xl sm:text-4xl lg:text-5xl text-center leading-tight`;
const Description = tw(SectionDescription)`w-full text-center`;

const VerticalSpacer = tw.div`mt-4 w-full`;

const Column = styled.div`
    ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const Card = styled.div`
    ${tw`flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left h-full mx-4 px-1 md:px-2 py-4 md:py-8`}
    .imageContainer {
        ${tw`border text-center rounded-full p-2 md:p-5 flex-shrink-0`}
        img {
            ${tw`w-5 h-5 md:w-6 md:h-6`}
        }
    }

    .textContainer {
        ${tw`sm:ml-4 mt-2 md:mt-4 sm:mt-2`}
    }

    .title {
        ${tw`mt-2 md:mt-4 tracking-wide font-bold text-xl md:text-2xl leading-none`}
    }

    .description {
        ${tw`mt-1 sm:mt-4 font-medium text-secondary-300`}
    }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
    ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

export default ({
    cards = null,
    heading = 'Amazing Features',
    subheading = 'Features',
    description = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
}) => {
    /*
     * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component) or you can directly pass this using the cards prop:
     *  1) imageSrc - the image shown at the top of the card
     *  2) title - the title of the card
     *  3) description - the description of the card
     *  If a key for a particular card is not provided, a default value is used
     */

    const defaultCards = [
        {
            imageSrc: ShieldIconImage,
            title: 'Secure',
            description: 'We strictly only deal with vendors that provide top notch security.',
        },
        { imageSrc: SupportIconImage, title: '24/7 Support' },
        { imageSrc: CustomizeIconImage, title: 'Customizable' },
        { imageSrc: ReliableIconImage, title: 'Reliable' },
        { imageSrc: FastIconImage, title: 'Fast' },
        { imageSrc: SimpleIconImage, title: 'Easy' },
    ];

    if (!cards) cards = defaultCards;

    return (
        <Container>
            <ThreeColumnContainer>
                {subheading && <Subheading>{subheading}</Subheading>}
                <Heading>{heading}</Heading>
                {description && <Description>{description}</Description>}
                <VerticalSpacer />
                {cards.map((card, i) => (
                    <Column key={i}>
                        <Card>
                            <span className="imageContainer">
                                <img src={card.imageSrc || defaultCardImage} alt="" />
                            </span>
                            <span className="textContainer">
                                <span className="title">{card.title || 'Fully Secure'}</span>
                                <p className="description">
                                    {card.description ||
                                        'Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud.'}
                                </p>
                            </span>
                        </Card>
                    </Column>
                ))}
            </ThreeColumnContainer>
            <DecoratorBlob />
        </Container>
    );
};
